import { render } from "./Home.vue?vue&type=template&id=4bb63167&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4bb63167&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb63167"]])

export default __exports__